import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({ title: 'Sales Division Master', screenId: '6.1.3', module: 'POS', apiBase: 'api/pos', apiPath: 'salesdivision', screenName: 'SalesDivisionMaster', idField: 'DivId', nameField: 'DivName',
  gridColumns: [{ field: 'DivId', header: 'Division ID' }, { field: 'DivName', header: 'Division Name' }],
  formFields: [{ field: 'DivId', label: 'Division Id', disabled: true }, { field: 'DivName', label: 'Division Name', required: true }]
});
